import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SuiContainer } from '@splashthat/sui';

import { getSubmitButtonLabel } from 'common/entities/form/selectors';
import { setSubmitButtonLabel } from 'common/entities/form';

import { getFormId } from '../../selectors';
import { saveEditForm } from '../../actions';

import EditViewHeader from './EditViewHeader';
import EditViewSectionContainer from './EditViewSectionContainer';
import DraftTextEditorWrapper from './components/DraftTextEditorWrapper';

const HEADER_LABEL = 'Submit Button';
const EDIT_QUESTION_LABEL = 'Text';
const SUBMIT_BUTTON_LABEL = 'Submit';
const INPUT_PLACEHOLDER = 'This will appear on your form.';

const baseClassName = 'EditFormSubmitButtonPanel';

/**
 * Edit view for changing the form entity (like form headline)
 */
class EditFormSubmitButtonPanel extends Component {
    static propTypes = {
        submitButtonLabel: PropTypes.string.isRequired,
        formId: PropTypes.string.isRequired,
        saveEditForm: PropTypes.func.isRequired,
        setSubmitButtonLabel: PropTypes.func.isRequired,
    };

    handleChangeLabel = (event, label, labelMarkup) => {
        this.props.setSubmitButtonLabel(this.props.formId, labelMarkup);
    };

    render() {
        const { submitButtonLabel } = this.props;
        return (
            <SuiContainer variation="flex-vertical" className={baseClassName}>
                <EditViewHeader label={HEADER_LABEL} saveEditFormNode={this.props.saveEditForm} locked={false} />
                <SuiContainer className={`${baseClassName}__content-container`}>
                    <EditViewSectionContainer>
                        <SuiContainer variation="flex-group">
                            <DraftTextEditorWrapper
                                fullWidth
                                label={EDIT_QUESTION_LABEL}
                                value={submitButtonLabel}
                                defaultValue={SUBMIT_BUTTON_LABEL}
                                placeholder={INPUT_PLACEHOLDER}
                                onChangeLabel={this.handleChangeLabel}
                                disableBold
                                disableLink
                            />
                        </SuiContainer>
                    </EditViewSectionContainer>
                </SuiContainer>
            </SuiContainer>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const submitButtonLabel = getSubmitButtonLabel(state, formId);

    return {
        formId,
        submitButtonLabel,
    };
};
const mapDispatchToProps = {
    saveEditForm,
    setSubmitButtonLabel,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditFormSubmitButtonPanel);
